import type { ComponentType } from 'react';
import type { FieldSchema } from '../types';
import type { Group } from '../models/Group';
import { TextField } from './fields/TextField';
import { TextAreaField } from './fields/TextAreaField';
import { EmailField } from './fields/EmailField';
import { PhoneField } from './fields/PhoneField';
import { NumericField } from './fields/NumericField';
import { DateField } from './fields/DateField';
import { MonthYearField } from './fields/MonthYearField';
import { RadioField } from './fields/RadioField';
import { RadioListField } from './fields/RadioListField';
import { CheckListField } from './fields/CheckListField';
import { CheckBoxField } from './fields/CheckBoxField';
import { DropDownField } from './fields/DropDownField';
import { LocationField } from './fields/LocationField';
import { FileUploadField } from './fields/FileUploadField';
import { ReadOnlyField } from './fields/ReadOnlyField';
import { MessageField } from './fields/MessageField';
import { CalloutField } from './fields/CalloutField';

const fieldComponents: Record<string, ComponentType<{ fieldSchema: FieldSchema; group: Group }>> = {
  Text: TextField,
  TextArea: TextAreaField,
  Email: EmailField,
  Phone: PhoneField,
  Numeric: NumericField,
  Date: DateField,
  DateText: DateField,
  MonthYear: MonthYearField,
  Radio: RadioField,
  RadioList: RadioListField,
  CheckList: CheckListField,
  CheckBox: CheckBoxField,
  DropDown: DropDownField,
  Location: LocationField,
  FileUpload: FileUploadField,
  ReadOnly: ReadOnlyField,
  Message: MessageField,
  Callout: CalloutField,
};

export function FieldRenderer({ fieldSchema, group }: { fieldSchema: FieldSchema; group: Group }) {
  const Component = fieldComponents[fieldSchema.type];

  if (!Component) {
    return null;
  }

  return <Component fieldSchema={fieldSchema} group={group} />;
}

export function registerFieldComponent(
  type: string,
  component: ComponentType<{ fieldSchema: FieldSchema; group: Group }>
): void {
  fieldComponents[type] = component;
}
